var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.7281 13.2824L16.8115 11.7608C16.619 11.4216 16.4448 10.7799 16.4448 10.4041V8.08492C16.4448 5.93075 15.1798 4.06992 13.3556 3.19909C12.879 2.35575 11.999 1.83325 10.9906 1.83325C9.99145 1.83325 9.09312 2.37409 8.61645 3.22659C6.82895 4.11575 5.59145 5.95825 5.59145 8.08492V10.4041C5.59145 10.7799 5.41728 11.4216 5.22478 11.7516L4.29895 13.2824C3.93228 13.8966 3.84978 14.5749 4.07895 15.1983C4.29895 15.8124 4.82145 16.2891 5.49978 16.5183C7.27812 17.1233 9.14812 17.4166 11.0181 17.4166C12.8881 17.4166 14.7581 17.1233 16.5365 16.5274C17.1781 16.3166 17.6731 15.8308 17.9115 15.1983C18.1498 14.5658 18.0856 13.8691 17.7281 13.2824Z",
    stroke: "#161720"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5942 18.3424C13.2092 19.4058 12.1917 20.1666 11 20.1666C10.2759 20.1666 9.56087 19.8733 9.05671 19.3508C8.76337 19.0758 8.54337 18.7091 8.41504 18.3333C8.53421 18.3516 8.65337 18.3608 8.78171 18.3791C8.99254 18.4066 9.21254 18.4341 9.43254 18.4524C9.95504 18.4983 10.4867 18.5258 11.0184 18.5258C11.5409 18.5258 12.0634 18.4983 12.5767 18.4524C12.7692 18.4341 12.9617 18.4249 13.145 18.3974C13.2917 18.3791 13.4384 18.3608 13.5942 18.3424Z",
    stroke: "#161720"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.891ac8a7c467bb099beeb722b3662d02.svg";
export { ForwardRef as ReactComponent };